import { css } from '@emotion/react'
import {
  CornerRadius,
  gemVar,
  LineWeight,
  Spacing,
  ThemedColors,
  Typography,
} from '@opallabs/gem'

const rootClass = 'opal-workspace-month-calendar'
export const selectors = {
  root: rootClass,
  banner: `${rootClass}-banner`,
  contents: `${rootClass}-contents`,
  grid: `${rootClass}-grid`,
} as const

/** The control bar over the whole width, then the grid and the panel below it. */
export const root = css({
  blockSize: '100%',
  display: 'flex',
  flexDirection: 'column',
  minBlockSize: 0,
})

/**
 * The grid and the panel beside it. The control bar belongs to the view rather
 * than to the grid, so opening the panel takes width from the grid alone — a
 * panel that reached the top of the view read as a page with a header of its
 * own.
 */
export const contents = css({
  borderBlockStart: `${LineWeight.Small}px solid ${gemVar(
    ThemedColors.StrokeSecondary1
  )}`,
  display: 'flex',
  flex: 1,
  minBlockSize: 0,
  minInlineSize: 0,
  position: 'relative',
})

/** The truncation banner, when there is one, and the grid under it. */
export const grid = css({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minBlockSize: 0,
  minInlineSize: 0,
})

export const banner = css({
  ...Typography.T300,
  alignItems: 'center',
  background: gemVar(ThemedColors.Surface2),
  border: `${LineWeight.Small}px solid ${gemVar(
    ThemedColors.StrokeSecondary1
  )}`,
  borderRadius: CornerRadius.Small,
  color: gemVar(ThemedColors.TextSecondary),
  display: 'flex',
  gap: Spacing.XS,
  justifyContent: 'space-between',
  margin: `${Spacing.XS}px ${Spacing.S}px`,
  padding: `${Spacing.XS}px ${Spacing.S}px`,
})
